import React from "react";
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	MenuItem,
	Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./MobileMenu.css";

const MobileMenu = ({ categories, toggleNavMenu, expanded, handleChange }) => {
	return categories?.map(({ idCategory, name, routeURL, subcategories }) => (
		<Accordion
			expanded={expanded === `panel${idCategory}`}
			onChange={handleChange(`panel${idCategory}`)}
			TransitionProps={{ unmountOnExit: true }}
			key={idCategory}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={`panel${idCategory}-content`}
				id={`panel${idCategory}-header`}
			>
				<Typography sx={{ width: "90%", flexShrink: 0 }}>{name}</Typography>
			</AccordionSummary>
			<AccordionDetails>
				<MenuItem onClick={toggleNavMenu} divider dense={true}>
					<Link to={routeURL} className="menu-links">
						{name}
					</Link>
				</MenuItem>
				{subcategories?.map((subcategory) => (
					<MenuItem
						key={subcategory.idSubCategory}
						onClick={toggleNavMenu}
						divider
						dense={true}
					>
						<Link to={subcategory.routeURL} className="menu-links">
							{subcategory.name}
						</Link>
					</MenuItem>
				))}
			</AccordionDetails>
		</Accordion>
	));
};

export default MobileMenu;
